import React from 'react';

function NotFound() {
    return (
        <h1 className="app404"><span className="mdi mdi-power-plug-off"/>Not found</h1>
    );
}

export default NotFound;
